import { ReactNode } from 'react';
import { Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Box } from '@mui/system';


interface ILayoutBaseDePaginaProps {
    titulo: string;
    children: React.ReactNode
    barraDeFerramentas?: ReactNode;
}

export const LayoutBaseDeFolha: React.FC<ILayoutBaseDePaginaProps> = ({ 
  children, 
  titulo, 
  barraDeFerramentas,
}) => {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const theme = useTheme();

  return (
    <Box  height="100%" display="flex" flexDirection="column" gap={1} >
      <Box padding={1} paddingX={smDown ? 2 : 1} display="flex" alignItems="center" gap={1} minHeight={theme.spacing(smDown ? 6 : mdDown ? 8 : 12)}>
        <Typography
          overflow="hidden"
          whiteSpace="nowrap"
          textOverflow="ellipses" 
          variant={smDown ? 'h5' : mdDown ? 'h4' : 'h3'}
          margin={smDown ? 0 : 5}
          sx={smDown ? { fontWeight: 800, fontSize: '1.6rem', letterSpacing: '-0.02em' } : undefined}
        >
          {titulo}
        </Typography>
     
      </Box>

      {barraDeFerramentas && (
        <Box>
          {barraDeFerramentas}
        </Box>
      )}

      <Box padding={1}  overflow="auto">
        {children}
      </Box>
    </Box>
  );
};